import { z } from 'zod'
import {
  nullSafeOptionalBoolean,
  nullSafeOptionalFirestoreTimestamp,
} from '../shared/schema'
import { PostRoomStatePromptType } from '../PromptPostRoomStateType/types'

export const schema = z.object({
  endedAt: nullSafeOptionalFirestoreTimestamp(),
  promptType: z.nativeEnum(PostRoomStatePromptType),
  promptVersionId: z.string(),
  roomId: z.string(),
  startedAt: nullSafeOptionalFirestoreTimestamp(),
  success: nullSafeOptionalBoolean(),
})

export const empty = Object.freeze(
  schema.parse({
    promptType: PostRoomStatePromptType.blindSpot,
    roomId: '',
    promptVersionId: '',
  })
)

export type FirestorePromptPostRoomStateAIEvent = z.infer<typeof schema>
